import { ACCEPT_STATUS_EVENT, CHAT_STATUS_EVENT, EVENT_TYPE, MESSAGE_TYPE } from './constantsLivePerson';
import { livePersonMessagesStatusManager } from './livePersonMessageStatusManager';
import { v4 as uuidV4 } from 'uuid';
import { submitMessageToLivePerson } from './submitLivePersonMessage';
import { handleCloseEvent } from './handleCloseEvent';
var livePersonAgentNickname = '';
var isAssignedToAnAgent = false;
export var handleEventsFromLivePerson = function (_a) {
    var livePersonEventSource = _a.livePersonEventSource, handleLivePersonOnMessageError = _a.handleLivePersonOnMessageError, syncChatMessage = _a.syncChatMessage, setCachedMessages = _a.setCachedMessages, setStreamingText = _a.setStreamingText, setErrorMessage = _a.setErrorMessage, setLivePersonAgentInitial = _a.setLivePersonAgentInitial, setLivePersonAgentName = _a.setLivePersonAgentName, setLivePersonConversationId = _a.setLivePersonConversationId, lpUserFirstName = _a.lpUserFirstName, lpUserLastName = _a.lpUserLastName, chatCustomerId = _a.chatCustomerId, submitMessageURL = _a.submitMessageURL, setIsLivePersonEnabled = _a.setIsLivePersonEnabled, setIsLivePersonSessionActive = _a.setIsLivePersonSessionActive, setCloseLpChat = _a.setCloseLpChat;
    return new Promise(function (resolve) {
        setStreamingText('Connecting...');
        livePersonEventSource.onmessage = function (event) {
            var _a, _b, _c, _d;
            try {
                var parsedData_1 = JSON.parse(event.data);
                if (parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.conversationId) {
                    setLivePersonConversationId(parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.conversationId);
                }
                // Setup agent name
                if ((parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.agentNickname) && livePersonAgentNickname !== (parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.agentNickname)) {
                    if (!isAssignedToAnAgent) {
                        isAssignedToAnAgent = true;
                    }
                    // set up agent name once connection build
                    livePersonAgentNickname = parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.agentNickname;
                    setLivePersonAgentName(livePersonAgentNickname || '');
                    var _e = (_a = parsedData_1.agentName) === null || _a === void 0 ? void 0 : _a.split(' '), firstName = _e[0], lastName = _e[1];
                    if (firstName && lastName) {
                        setLivePersonAgentInitial((_c = (_b = firstName === null || firstName === void 0 ? void 0 : firstName.charAt(0)) !== null && _b !== void 0 ? _b : '' + (lastName === null || lastName === void 0 ? void 0 : lastName.charAt(0))) !== null && _c !== void 0 ? _c : '');
                    }
                    // display agent name to the user
                    var contentSeparatorMessage = {
                        role: 'chatContentSeparator',
                        content: "You are now  connected to ".concat(parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.agentNickname),
                        key: 'agentConnected',
                    };
                    setCachedMessages(contentSeparatorMessage);
                    syncChatMessage();
                }
                if ((parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.eventType) === EVENT_TYPE.ChatStateEvent) {
                    if ((parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.eventDesc) === CHAT_STATUS_EVENT.COMPOSING && isAssignedToAnAgent) {
                        // display the agent typing status
                        setStreamingText("".concat(livePersonAgentNickname || 'Agent', " is typing ..."));
                    }
                    if ((parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.eventDesc) === CHAT_STATUS_EVENT.PAUSE && isAssignedToAnAgent) {
                        // display the agent typing status
                        setStreamingText('');
                    }
                }
                else if ((parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.eventType) === EVENT_TYPE.ContentEvent) {
                    var _f = ((_d = parsedData_1.agentName) === null || _d === void 0 ? void 0 : _d.split(' ')) || [], firstName = _f[0], lastName = _f[1];
                    // display agent message
                    var livePersonAgentMessage = {
                        role: 'livePersonAgent',
                        content: parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.eventDesc,
                        msgId: parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.sequenceId,
                        date: new Date(),
                        agentNickname: (parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.agentNickname) || 'agent',
                        agentInitial: firstName && lastName ? (firstName === null || firstName === void 0 ? void 0 : firstName.charAt(0)) + (lastName === null || lastName === void 0 ? void 0 : lastName.charAt(0)) : 'ag',
                    };
                    setCachedMessages(livePersonAgentMessage);
                    syncChatMessage();
                    // When sequenceId, submit ACCEPT event to LP service to indicate that client receive the message
                    if (parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.sequenceId) {
                        livePersonMessagesStatusManager.addPendingAgentSequenceIds(parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.sequenceId);
                        var lpData = {
                            messageType: MESSAGE_TYPE.MESSAGE,
                            conversationId: parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.conversationId,
                            eventType: EVENT_TYPE.AcceptStatusEvent,
                            eventDesc: ACCEPT_STATUS_EVENT === null || ACCEPT_STATUS_EVENT === void 0 ? void 0 : ACCEPT_STATUS_EVENT.ACCEPT,
                            sequenceList: [parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.sequenceId],
                        };
                        var msgId = uuidV4();
                        var livePersonMessagePayload = {
                            lpData: lpData,
                            user: {
                                firstName: lpUserFirstName,
                                lastName: lpUserLastName,
                            },
                            chatCustomerId: chatCustomerId,
                            msgId: msgId,
                        };
                        submitMessageToLivePerson({
                            requestOptions: {
                                url: submitMessageURL,
                                headers: {},
                            },
                            livePersonMessagePayload: livePersonMessagePayload,
                            handleLivePersonOnMessageError: handleLivePersonOnMessageError,
                        });
                    }
                }
                else if ((parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.eventType) === EVENT_TYPE.SequenceMapEvent) {
                    // map the lp sequenceId with user msgId
                    var sequenceMap = parsedData_1.sequenceMap;
                    if ((sequenceMap === null || sequenceMap === void 0 ? void 0 : sequenceMap.msgId) && (sequenceMap === null || sequenceMap === void 0 ? void 0 : sequenceMap.sequenceId)) {
                        livePersonMessagesStatusManager.linkSequenceIdWithMsgId(sequenceMap === null || sequenceMap === void 0 ? void 0 : sequenceMap.msgId, sequenceMap === null || sequenceMap === void 0 ? void 0 : sequenceMap.sequenceId);
                    }
                }
                else if ((parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.eventType) === EVENT_TYPE.AcceptStatusEvent) {
                    // Agent READ on one or some of the user's message
                    if ((parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.eventDesc) === CHAT_STATUS_EVENT.READ && (parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.sequenceList.length) !== 0) {
                        var sequenceList = parsedData_1.sequenceList;
                        sequenceList.forEach(function (sequenceId) {
                            var msgId = livePersonMessagesStatusManager.getMsgIdBySequenceId(sequenceId);
                            livePersonMessagesStatusManager.updateMessageStatusByMsgId(msgId, parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.eventDesc);
                        });
                        syncChatMessage();
                    }
                }
                else if ((parsedData_1 === null || parsedData_1 === void 0 ? void 0 : parsedData_1.eventType) === EVENT_TYPE.CLOSE) {
                    isAssignedToAnAgent = false;
                    handleCloseEvent({
                        setIsLivePersonSessionActive: setIsLivePersonSessionActive,
                        setIsLivePersonEnabled: setIsLivePersonEnabled,
                        setCloseLpChat: setCloseLpChat,
                        livePersonEventSource: livePersonEventSource,
                        setLivePersonAgentName: setLivePersonAgentName,
                        setLivePersonAgentInitial: setLivePersonAgentInitial,
                        livePersonAgentNickname: livePersonAgentNickname,
                        setStreamingText: setStreamingText,
                        setCachedMessages: setCachedMessages,
                        syncChatMessage: syncChatMessage,
                    });
                }
            }
            catch (err) {
                // return the error the host app to handle
                handleLivePersonOnMessageError(err);
                setErrorMessage('Sorry, system errors occur.');
            }
        };
        livePersonEventSource.onerror = function (event) {
            handleLivePersonOnMessageError("SSE Reconnecting/Error: event - ".concat(JSON.stringify(event, null, 2)));
        };
        livePersonEventSource.onopen = function (event) {
            resolve();
        };
    });
};
//# sourceMappingURL=handleLivePersonMessage.js.map